<div *ngIf="supplies; else noEstimate" class="supply-estimate">
  <p class="supply-estimate__count">
    Estimated strips/lancets remaining:
    {{ supplies.estimated_strips_remaining < 0 ? 0 : supplies.estimated_strips_remaining }} / {{ supplies.strips_sent }}
  </p>
  <p class="supply-estimate__note">
    This is an estimated value and may vary due to factors such as damaged strips or missed readings.
  </p>
</div>
<ng-template #noEstimate>
  <p class="supply-estimate__note supply-estimate__note--standalone">Supply estimate not available yet.</p>
</ng-template>
